import { Loader2 } from 'lucide-react'

/**
 * Small infinite spinner — wraps `lucide-react`'s `Loader2` with
 * the spin animation already applied so callers don't have to
 * remember the class.
 *
 * The component is intentionally trivial; it exists so a future
 * design-token swap (different speed, different colour) only
 * touches one file.
 */
interface SpinnerProps {
  className?: string
  size?: number
  label?: string
}

export function Spinner({ className, size = 20, label }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-live="polite"
      className={['inline-flex items-center gap-2', className ?? ''].join(' ')}
    >
      <Loader2 size={size} className="animate-spin" aria-hidden="true" />
      {label !== undefined ? <span className="sr-only">{label}</span> : null}
    </span>
  )
}
